var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { perkbox, warning } from "@irati/ui/src/global/colors";
import { TD_STYLE } from "@irati/ui/src/Table";
import { Label2, Label3 } from "@irati/ui/src/Labels";
import Flex from "@irati/ui/src/Flex";
import Pill from "@irati/ui/src/Pill";
import { PerkLogoImg, PerkRedemptionCount } from "./styled";
var createSignedPercentLabel2DP = function (num) {
    var num2DP = Math.round(num * 100) / 100;
    return num2DP > 0 ? "+" + num2DP + "%" : num2DP + "%";
};
var generateColumns = function (formatMessage) { return [
    {
        Header: function () { return null; },
        accessor: "title",
        Cell: function (props) { return React.createElement(PerkLogoImg, { src: props.row._original.iconURL }); },
        style: __assign(__assign({}, TD_STYLE), { border: "none" })
    },
    {
        Header: function () { return null; },
        accessor: "description",
        Cell: function (props) { return (React.createElement(Flex, { direction: "column" },
            React.createElement(Label2, null, props.row._original.title),
            React.createElement(Label3, null, props.row._original.description))); },
        minWidth: 120,
        style: __assign(__assign({}, TD_STYLE), { border: "none" })
    },
    {
        Header: function () { return formatMessage({ id: "admin.reportingV3.perkRedemptionTable.totalColumn" }); },
        Cell: function (props) { return React.createElement(PerkRedemptionCount, null, props.row._original.totalRedemptions); },
        accessor: "totalRedemptions"
    },
    {
        Header: function () { return formatMessage({ id: "admin.reportingV3.perkRedemptionTable.growthColumn" }); },
        accessor: "growth",
        Cell: function (props) { return (React.createElement(Pill, { text: createSignedPercentLabel2DP(props.row._original.growth), color: props.row._original.growth >= 0 ? perkbox.greenBlue : warning.default })); }
    }
]; };
export default generateColumns;
